import React, { useMemo } from 'react';
import { AlgoliaAppContext } from './App.context';
export const AlgoliaAppProvider = ({ children, pagePath }) => {
    const value = useMemo(() => ({
        pagePath
    }), []);
    return (React.createElement(AlgoliaAppContext.Provider, { value: value }, children));
};
